import { ref, computed, watch, isRef, type Ref, type ComputedRef } from 'vue'
import { useRoute } from 'vue-router'

type TitleValue = string | Ref<string> | ComputedRef<string> | (() => string)

const customTitle = ref<TitleValue>('') as Ref<TitleValue>
const customSubtitle = ref<TitleValue>('') as Ref<TitleValue>

function unwrapValue(val: TitleValue): string {
  if (typeof val === 'function') return val()
  if (isRef(val)) return val.value
  return String(val || '')
}

export function usePageTitle() {
  const route = useRoute()

  const setPageTitle = (title: TitleValue, subtitle: TitleValue = '') => {
    customTitle.value = title
    customSubtitle.value = subtitle
  }

  const resetPageTitle = () => {
    customTitle.value = ''
    customSubtitle.value = ''
  }

  watch(
    () => route.path,
    () => {
      resetPageTitle()
    }
  )

  const pageTitle = computed(() => {
    const custom = unwrapValue(customTitle.value)
    if (custom) return custom
    if (route?.meta?.title) {
      return String(route.meta.title)
    }
    return ''
  })

  const pageSubtitle = computed(() => {
    return unwrapValue(customSubtitle.value)
  })

  return {
    pageTitle,
    pageSubtitle,
    setPageTitle,
    resetPageTitle,
  }
}
